const sanitizeField = (value) => {
  const sanitizedValue = String(value).replace(/[^0-9.+-]/g, '');

  const sanitizedValueNumber = Number(sanitizedValue);

  if (sanitizedValue.endsWith('.')) {
    return sanitizedValue;
  }

  if (sanitizedValueNumber > 0) {
    return `+${sanitizedValueNumber}`;
  }

  if (sanitizedValueNumber < 0) {
    return `${sanitizedValueNumber}`;
  }

  return sanitizedValue;
};

const isCostAdjustMentValid = (value) => {
  const valueNumber = Number(value);
  return !Number.isNaN(valueNumber);
};

const getNetMarginValue = ({ adjustment, price, cost }) => {
  const adjustmentValue = Number(adjustment || 0);

  if (Number.isNaN(adjustmentValue)) {
    return '-';
  }

  const calculatedNetmargin = price - (cost + adjustmentValue || 0);

  return calculatedNetmargin.toFixed(2);
};

export { sanitizeField, isCostAdjustMentValid, getNetMarginValue };
